export default __webpack_public_path__ + "static/media/tit.07b7f74e.png";